export class AppMessage {

    getItem = new Array();

    constructor() {
        // Map with server (Back-end)
        this.getItem['Common001'] = 'Internal server error.';
        this.getItem['Common002'] = 'Bad Request';
        this.getItem['Common003'] = "No record found.";
        this.getItem['Common004'] = "Data saved.";
        this.getItem['Common005'] = "Something went wrong. Please try later.";
        this.getItem['Common006'] = "Not sure";
        this.getItem['Common007'] = "Are you sure?";
        this.getItem['Common008'] = "Success";
        this.getItem['Common009'] = "Continue";
        this.getItem['Common010'] = "Oops!";
        this.getItem['Common011'] = "OK";
        this.getItem['Common012'] = "Invalid inputs";
        this.getItem['Common013'] = "Congratulations";
        this.getItem['Common014'] = "Yes";
        this.getItem['Common015'] = "No";

        this.getItem['E1000'] = "User doesn't exist in the Scheduling Application";
        this.getItem['E1001'] = "User Not authenticated";
        this.getItem['E1002'] = "You do not have access to: Candidate page";
        this.getItem['E1003'] = "No user exist for given credentials";
        this.getItem['E1004'] = "You do not have access to: Admin page";
        this.getItem['E1005'] = "No Admin user exist for given credentials";
        this.getItem['E1006'] = "Access Denied";
        this.getItem['E1007'] = "Invalid token ";
        this.getItem['E1008'] = "User is not authenticated or authorized to access";
        this.getItem['E1009'] = "Please pass the token";
        this.getItem['E1010'] = "No policy found";
        this.getItem['E1011'] = "Required Field Missing";
        this.getItem['E1012'] = "Invalid Email Id";
        this.getItem['E1013'] = "Invalid Value Passed for Field";
        this.getItem['E1014'] = "Invalid file selected for upload";
        this.getItem['E1015'] = "ApprovalId size exceeded";
        this.getItem['E1016'] = "Invalid date";
        this.getItem['E1017'] = "email id doesnot belong to candidate";
        this.getItem['E1018'] = "Token expired";
        this.getItem['E1019'] = "Provide valid parameter";
        this.getItem['E1020'] = "Required field is missing";
        this.getItem['E1022'] = "Invalid Exam Status provided";
        this.getItem['E1023'] = "Invalid Content Type";
        this.getItem['E1024'] = "Uploaded File is empty";
        this.getItem['E1025'] = "Country doesn't require ID to be uploaded";
        this.getItem['E1026'] = "Identity Document Already uploaded under pending approval state";
        this.getItem['E1027'] = "Internal server Error. Unable to upload file";
        this.getItem['E1028'] = "Country id entered is invalid";
        this.getItem['E1029'] = "Internal server Error.";
        this.getItem['E1030'] = "method not allowed";
        this.getItem['E1031'] = "selected exam does not exist";
        this.getItem['E1032'] = "Required Field is missing";
        this.getItem['E1033'] = "file field is missing";
        this.getItem['E1034'] = "No Locations Found";
        this.getItem['E1035'] = "No such exam exists";
        this.getItem['E1036'] = "To date/time can't be less than From date/time";
        this.getItem['E1037'] = "No time zone exist for given id";
        this.getItem['E1038'] = "User is not eligible for given exam";
        this.getItem['E1039'] = "Selected input date is before current date";
        this.getItem['E1040'] = "Selected input date is beyond eligibility expiry date";
        this.getItem['E1041'] = "Email could not be sent";
        this.getItem['E1042'] = "Identity Document Already uploaded and approved";
        this.getItem['E1043'] = "No proctor exist";
        this.getItem['E1044'] = "This eligibility does not exist for the current user";
        this.getItem['E1045'] = "This exam can not be canceled";
        this.getItem['E1046'] = "The Exam date has already passed";
        this.getItem['E1047'] = "Unable to Reschedule exam. Exam date is within 24 hrs";
        this.getItem['E1048'] = "This eligibility is already scheduled.";
        this.getItem['E1049'] = "The authentication credentials supplied for the SMTP server are not correct or have expired or check Allow less secure apps: ON in your google settings";
        this.getItem['E1050'] = "This eligibility is already taken";
        this.getItem['E1051'] = "Exam name does not exist";
        this.getItem['E1052'] = "Sorry, your exam could not be scheduled. Please try again";
        this.getItem['E1053'] = "Unable to Schedule exam. Exam date is within 24 hrs";
        this.getItem['E1054'] = "The exam is not scheduled.";
        this.getItem['E1055'] = "No result found";
        this.getItem['E1056'] = "Exam has expired because it was canceled in less than 24 hours remaining for the scheduled time. ";
        this.getItem['E1057'] = "Exam Status Codes not found.";
        this.getItem['E1058'] = "Exam with that Code and Type already exists";
        this.getItem['E1059'] = "Total time exceeds from 24 hours.";
        this.getItem['E1060'] = "Transaction failed, please try again! ";
        this.getItem['E1061'] = "Sorry, Exam could not be claimed";
        this.getItem['E1062'] = "Sorry, Observer could not be updated";
        this.getItem['E1063'] = "No Record Found";
        this.getItem['E1064'] = "No Connection to the Database can be Found";
        this.getItem['E1066'] = "Invalid date or time";
        this.getItem['E1067'] = "Email Id does not belong to candidate";
        this.getItem['E1068'] = "No exam session exists for current date";
        this.getItem['E1069'] = "Incorrect parameter";
        this.getItem['E1070'] = "Incorrect total time";
        this.getItem['E1071'] = "Global Administrator already exists";
        this.getItem['E1072'] = "No such Global Administrator exists";
        this.getItem['E1073'] = "Invalid Contact Number";
        this.getItem['E1074'] = "System with entered Mac address and Serial number are already requested";
        this.getItem['E1075'] = "Required MacAddress is Missing";
        this.getItem['E1076'] = "Required SerialNo is Missing";
        this.getItem['E1077'] = "MacAddress size exceeded";
        this.getItem['E1078'] = "SerialNo size exceeded";
        this.getItem['E1079'] = "No such location found";
        this.getItem['E1080'] = "System cannot be requested";
        this.getItem['E1081'] = "Required LocationId is Missing";
        this.getItem['E1082'] = "Status could not be changed. Please try again later.";
        this.getItem['E1083'] = "Record Already Exists";
        this.getItem['E1084'] = "No record found for the given location Id";
        this.getItem['E1085'] = "location with entered location name is already requested";
        this.getItem['E1086'] = "location name size exceeds";
        this.getItem['E1087'] = "street address1 size exceeds";
        this.getItem['E1088'] = "street address2 size exceeds";
        this.getItem['E1089'] = "zip size exceeds";
        this.getItem['E1090'] = "Details could not be updated";
        this.getItem['E1091'] = "Invalid input : id";
        this.getItem['E1092'] = "Invalid input : inputType";
        this.getItem['E1093'] = "Invalid input : outputType";
        this.getItem['E1094'] = "Policy updated successfully";
        this.getItem['E1095'] = "No policy found";
        this.getItem['E1096'] = "No such proctor group exists";
        this.getItem['E1097'] = "No such exam session exist for today's date";
        this.getItem['E1098'] = "No such exam exists";
        this.getItem['E1099'] = "Date time parsing issue";
        this.getItem['E1100'] = "Invalid data";

        this.getItem['E1101'] = "Parameter Length exceeded limit.Please try again.";
        this.getItem['E1112'] = "MacAddress should be in this format FF:FF:FF:FF:FF:FF";
        this.getItem['E1113'] = "Oops, something went wrong.Please try again.";
        this.getItem['E1114'] = "Invalid time for field evaluation Time";
        this.getItem['E1115'] = "Invalid time for field exam Length";
        this.getItem['E1116'] = "Invalid time for field setup Time";
        this.getItem['E1117'] = "Invalid time for field pad Time";
        this.getItem['E1118'] = "Invalid time for field Total Exam Time";
        this.getItem['E1119'] = "Invalid Value Passed for Field exam name";
        this.getItem['E1120'] = "Invalid Value Passed for Field exam code";
        this.getItem['E1121'] = "Maximum size exceeds for field exam name";
        this.getItem['E1122'] = "Maximum size exceeds for field exam code";
        this.getItem['E1123'] = "Required Field evaluation Time Missing";
        this.getItem['E1124'] = "Required Field exam Length Missing";
        this.getItem['E1125'] = "Required Field Setup Time Missing";
        this.getItem['E1126'] = "Required Field Pad Time Missing";
        this.getItem['E1127'] = "Required Field Total Exam Time Missing";
        this.getItem['E1128'] = "Required Field exam name Missing";
        this.getItem['E1129'] = "Required Field exam code Missing";
        this.getItem['E1130'] = "Sorry exam could not be black listed";
        this.getItem['E1131'] = "This Exam is retired and cannot be scheduled at this moment";
        this.getItem['E1132'] = "Please select any search parameter";
        this.getItem['E1133'] = "Google is unable to locate address. Please correct your address.";
        this.getItem['E1134'] = "Regional Administrator can manage only site Administrators";
        this.getItem['E1136'] = "Please select some location";
        this.getItem['E1137'] = "No pending error cases";
        this.getItem['E1138'] = "Office added failure";
        this.getItem['E1139'] = "Office replaced failure";
        this.getItem['E1140'] = "Office deleted failure";
        this.getItem['E1141'] = "Office with same name already exists";
        this.getItem['E1142'] = "Required Field Action Missing";
        this.getItem['E1143'] = "No Office found. Please select another office";
        this.getItem['E1144'] = "Email or RhId is already used. Please choose another one.";
        this.getItem['E1145'] = "Request type is invalid.";
        this.getItem['E1146'] = "Some invalid data. Please check";
        this.getItem['E1147'] = "Required field is missing. Please check";
        this.getItem['E1148'] = "Sorry, exam could not be claimed";
        /**commented code 1149 to show dynamic msg coming from back end */
        //this.getItem['E1149'] = "You cannot schedule this exam at the moment. Please contact Red Hat Admin for more information.";//"You cannot schedule this exam at the moment, you can schedule on and after";
        this.getItem['E1150'] = "Procter Lead already exist";
        this.getItem['E1151'] = "You can not update hours. Please resolve below conflicts to update universal hours of operation.";
        //this.getItem['E1152'] = "Please enter valid value for FirstName or LastName";
        this.getItem['E1153'] = "You can not add closure, please resolve below conflicts first to add closure for the selected day(s)";

        this.getItem['E1155'] = "Id has been already processed.";
        this.getItem['E1156'] = "Cannot be updated";
        this.getItem['E1157'] = "You can not update Exam times, please resolve below conflicts first to update Exam times.";
        this.getItem['E1158'] = "Group Name can not be Found. Please try again.";
        this.getItem['E1159'] = "Input userId does not belong to candidate. Please try again.";
        this.getItem['E1160'] = "No exams are currently available to schedule";
        this.getItem['E1161'] = "Exam Eligibility can not be canceled.";
        this.getItem['E1162'] = "Exam Eligibility has been canceled.";
        this.getItem['E1163'] = "Site Administrator already exists.";
        this.getItem['E1164'] = "Regional Administrator already exists.";
        this.getItem['E1165'] = "You can not update office with the same office name. Please choose another one";
        this.getItem['E1071'] = "User already exists.";
        this.getItem['E1166'] = "This account is not authorized for access";
        this.getItem['E1171'] = "Failed sending messages. Please try again later";

        // local side
        this.getItem['UMsg00001'] = "This Exam is retired and can\'t be scheduled at this moment.";
        this.getItem['UMsg00002'] = "This exam can\'t be scheduled, as eligibility is expiring within 24Hrs.";
        this.getItem['UMsg00003'] = "This Exam is retired and can\'t be re-scheduled at this moment.";
        this.getItem['UMsg00004'] = "Unable to re-schedule exam. Exam date is within 24Hrs.";//"This exam can\'t be re-scheduled, as its already scheduled for today.";
        this.getItem['UMsg00005'] = "Site Administrator saved successfully";
        this.getItem['UMsg00006'] = "Site Administrator updated successfully";
        this.getItem['UMsg00007'] = "System with entered Mac address or Serial number are already requested";
        this.getItem['UMsg00008'] = "Mac Address’s requested successfully";
        this.getItem['UMsg00009'] = "Location setting updated successfully";
        this.getItem['UMsg00010'] = "Exam has been canceled successfully";
        this.getItem['UMsg00011'] = "You can\'t cancel this exam.";
        this.getItem['UMsg00012'] = "Exams canceled within 24 hours of their scheduled start time are not eligible for being rescheduled. Canceling now will consume your current attempt. If you do not have any attempts left, you will need to purchase the exam again in order to take it at another time. Do you wish to continue?";
        this.getItem['UMsg00013'] = "Cancel Exam";
        this.getItem['UMsg00014'] = "Can't Re-schedule";
        this.getItem['UMsg00015'] = "Can't Schedule";
        this.getItem['UMsg00016'] = "Invalid Country";
        this.getItem['UMsg00017'] = "Please select a country!";
        this.getItem['UMsg00018'] = "Uploaded";
        this.getItem['UMsg00019'] = "Invalid file format";
        this.getItem['UMsg00020'] = "Invalid file selected to upload. You can upload only jpg/png/pdf files.";
        this.getItem['UMsg00021'] = "Filesize exceeds limit";
        this.getItem['UMsg00022'] = "You can upload only jpg/png/pdf files upto maximum 5 mb size.";
        this.getItem['UMsg00023'] = "Please select an ID to upload.";
        this.getItem['UMsg00024'] = "You have successfully rescheduled your exam.";
        this.getItem['UMsg00025'] = "You have successfully scheduled your exam.";

        this.getItem['UMsg00026'] = "System has been Activated";
        this.getItem['UMsg00027'] = "System has been Retired";
        this.getItem['UMsg00028'] = "System is no more available";
        this.getItem['UMsg00029'] = "Location updated successfully";
        this.getItem['UMsg00030'] = "Record saved successfully";
        this.getItem['UMsg00031'] = "Record updated successfully";
        this.getItem['UMsg00032'] = "retired successfully"; // will append prefix based on condition
        this.getItem['UMsg00033'] = "Exam added successfully.";
        this.getItem['UMsg00034'] = "Exam updated successfully.";
        this.getItem['UMsg00035'] = "Exam retired successfully.";
        this.getItem['UMsg00036'] = "Exam activated successfully.";
        this.getItem['UMsg00037'] = "You want to retire this exam.";
        this.getItem['UMsg00038'] = "You want to activate this exam.";
        this.getItem['UMsg00039'] = "Policy updated successfully.";
        this.getItem['UMsg00040'] = "Are you sure you want to add new Group?";
        this.getItem['UMsg00041'] = "Are you sure you want to add Keyboard Type?";
        this.getItem['UMsg00042'] = "Are you sure you want to add Business Center?";
        this.getItem['UMsg00043'] = "Location added successfully";
        this.getItem['UMsg00044'] = "Location has been retired";
        this.getItem['UMsg00045'] = "Location has been activated";
        this.getItem['UMsg00046'] = "Are you sure you want to change Status?";
        this.getItem['UMsg00047'] = "Select yes to remove this user.";
        this.getItem['UMsg00048'] = "User has been removed successfully.";
        this.getItem['UMsg00049'] = "Select Yes to retire this Administrator.";
        this.getItem['UMsg00050'] = "User has been added successfully.";
        this.getItem['UMsg00051'] = "Select Yes to remove this calendar exception.";
        this.getItem['UMsg00052'] = "Calendar exception removed successfully.";
        this.getItem['UMsg00053'] = "You want to update this exam.";
        this.getItem['UMsg00054'] = "You want to add this exam.";
        this.getItem['UMsg00055'] = "Your ID has been uploaded successfully and has been sent for approval.";
        this.getItem['UMsg00056'] = "Uploaded ID has been approved.";
        this.getItem['UMsg00057'] = "Uploaded ID has been rejected.";
        this.getItem['UMsg00058'] = "Select Yes to block the calendar on the specified dates and times.";
        this.getItem['UMsg00059'] = "You can not add closure, please resolve below conflicts to add closure for the selected day(s).";
        this.getItem['UMsg00060'] = "Default concurrent exam capacity successfully updated.";
        this.getItem['UMsg00061'] = "Office added successfully";
        this.getItem['UMsg00062'] = "Some of the records get affected when removing an office";
        this.getItem['UMsg00063'] = "you want to remove this office.";
        this.getItem['UMsg00064'] = "Office removed successfully";
        this.getItem['UMsg00065'] = "Office replaced successfully";
        this.getItem['UMsg00067'] = "Proctor Team Lead retired successfully.";
        this.getItem['UMsg00068'] = "Proctor Team Lead activated successfully.";
        this.getItem['UMsg00069'] = "Select yes to update universal hours of operation.";
        this.getItem['UMsg00070'] = "Cannot Update Hours. Please resolve below conflicts to update universal hours of operation.";
        this.getItem['UMsg00071'] = "Exam retired";
        this.getItem['UMsg00072'] = "Proctor retired successfully.";
        this.getItem['UMsg00073'] = "Proctor activated successfully.";
        this.getItem['UMsg00074'] = "Are you sure you want to logout?";
        this.getItem['UMsg00075'] = "This account is not authorized for access.";
        this.getItem['UMsg00076'] = "Record retained successfully";
        this.getItem['UMsg00077'] = "Record released successfully";
        this.getItem['UMsg00078'] = "Pending Approval";
        this.getItem['UMsg00079'] = "You have selected a timeslot that exceeds the the maximum number of concurrent exams. Do you wish to continue.";
        this.getItem['UMsg00080'] = "Configuration saved successfully";
        this.getItem['UMsg00081'] = "activated successfully"; // will append prefix based on condition
        this.getItem['UMsg00082'] = "Select Yes to activate this Administrator.";
        this.getItem['UMsg00083'] = "There are no failed messages to be pushed";
        this.getItem['UMsg00084'] = "Process initiated successfully. Please check Message's status after some time.";
        this.getItem['UMsg00085'] = "Domains saved successfully";
        this.getItem['UMsg00086'] = "Duplicate domains found. Please check Whitelist or Blacklist values.";
        this.getItem['UMsg00087'] = "You can add maximum 50 Whitelist and BlackList domains."
        this.getItem['UMsg00088'] = "Domain length exceeds from 50 Chars. Please check.";
        this.getItem['UMsg00089'] = "Domain name is not in proper format.";
        this.getItem['UMsg00090'] = "NOTE: You must close your browser or clear your cookies to completely log out.",
        this.getItem['UMsg00091'] = "Chat Idle Time updated successfully.";
        this.getItem['UMsg00092'] = "You are about to cancel your exam session.  Do you want to continue?";
        this.getItem['UMsg00093'] = "Concurrent exam capacity schedule successfully updated.";
        this.getItem['UMsg00094'] = "No time zone selected.";
        this.getItem['UMsg00095'] = "No country selected.";
        this.getItem['UMsg00096'] = "The selected exam type is not available in that country";
        this.getItem['UMsg00097'] = "Country updated";
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/appMessage.ts